import BaseApi, { FetchMethodType } from 'api/BaseApi';

import { IApplicationDocument } from './DocumentsApi';
import { ITask, TaskStatus } from './TasksApi';

export interface ISubmitTaskParams {
  applicationId: string;
  taskId: string;
  taskStatus: TaskStatus;
  files?: File[];
  comment?: string;
}

export interface IComment {
  id: string;
  message: string;
  createdAt: Date;
}

export interface IGetTaskDetailsParams {
  taskId: string;
  applicationId: string;
}

interface IGetTaskDetailsResponse {
  task: ITask;
  comments: IComment[];
  documents: IApplicationDocument[];
}

export interface ITaskDetailsApi {
  getTaskDetails(params: IGetTaskDetailsParams): Promise<IGetTaskDetailsResponse>;
  submit(params: ISubmitTaskParams): Promise<ITask>;
}

export default class TaskDetailsRestApi extends BaseApi implements ITaskDetailsApi {
  public getTaskDetails({ taskId, applicationId }: IGetTaskDetailsParams) {
    const params = new URLSearchParams();

    params.append('taskId', taskId);
    params.append('applicationId', applicationId);

    return this.fetch<IGetTaskDetailsResponse>(`/task-details?${params}`);
  }

  public submit(params: ISubmitTaskParams) {
    const formData = new FormData();

    formData.append('applicationId', params.applicationId);
    formData.append('taskId', params.taskId);
    formData.append('taskStatus', params.taskStatus);

    if (params.comment) {
      formData.append('comment', params.comment);
    }

    if (params.files) {
      params.files.forEach((file) => {
        formData.append('files', file);
      });
    }

    return this.fetch<ITask>('/task-details', {
      method: FetchMethodType.PUT,
      body: formData,
      resetDefaultHeaders: true,
    });
  }
}
